import { render } from "./IndividualContent.vue?vue&type=template&id=f6710bca&scoped=true"
import script from "./IndividualContent.vue?vue&type=script&lang=js"
export * from "./IndividualContent.vue?vue&type=script&lang=js"

import "./IndividualContent.vue?vue&type=style&index=0&id=f6710bca&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/solution/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6710bca"]])

export default __exports__